import { routerMiddleware } from 'connected-react-router';
import { createStore, applyMiddleware, compose } from 'redux';
import thunkMiddleware from 'redux-thunk';
import { createBrowserHistory } from 'history';

import createRootReducer from '@app/reducers';
import { languages, messages } from '@app/constants/localization';

export const history = createBrowserHistory();

const activeLanguage = localStorage.getItem('language') || languages.AR;

const initialState = {
  intl: {
    locale: activeLanguage,
    messages: messages[activeLanguage],
  },
};

const middleware = applyMiddleware(routerMiddleware(history), thunkMiddleware);

/* eslint-disable no-underscore-dangle */
const reduxDevTool = process.env.NODE_ENV === 'development' ? window.__REDUX_DEVTOOLS_EXTENSION__ : undefined;
/* eslint-enable */

const storeWithMiddleware = reduxDevTool ? compose(middleware, reduxDevTool && reduxDevTool()) : compose(middleware);

export default function configureStore() {
  return createStore(
    createRootReducer(history),
    initialState,
    storeWithMiddleware,
  );
}
